import { API_PATH } from '../const/api_paths'
import { getBearerToken, removeAuthToken } from './_auth';

export const doGet = function (endpoint, data, callback = {}) {
  var headers = {
    method:   "GET",
    mode:     "cors",
    cache:    "no-cache",
    headers:  {"Content-Type": "application/json"},
    body:     JSON.stringify(data)
  }
  doFetch(endpoint, headers, callback)
}

export const doPost = (endpoint, data, callback = {}) => {
  var options = {
    method:   "POST",
    mode:     "cors",
    cache:    "no-cache",
    headers:  {"Content-Type": "application/json"},
    body:     JSON.stringify(data)
  }
  doFetch(endpoint, options, callback)
}

export const doPostWithHeaders = (endpoint, data, callback = {}) => {
  var options = {
    method:   "POST",
    headers:  {'Accept': 'application/json','Content-Type': 'application/json'},
    body:     JSON.stringify(data)
  }
  doFetchWithHeaders(endpoint, options, callback)
}

export const doAuthenticatedGet = (endpoint, data, callback = {}) => {
  const windowGlobal = typeof window !== 'undefined' && window
  var token = windowGlobal.localStorage.getItem('billebotAuthToken')
  var headers = new Headers()
  headers.append("Accept", "application/json")
  headers.append("Content-Type", "application/json")
  headers.append("Authorization", `Bearer ${token}`)

  var options = {
    method:   "GET",
    mode:     "cors",
    cache:    "no-cache",
    headers:  headers,
  }
  doFetch(addQueryString(endpoint, data), options, callback)
}

export const doAuthenticatedPost = (endpoint, data, callback = {}) => {
  const windowGlobal = typeof window !== 'undefined' && window
  var token = windowGlobal.localStorage.getItem('billebotAuthToken')
  var headers = new Headers()
  headers.append("Content-Type", "application/json")
  headers.append("Authorization", `Bearer ${token}`)

  var options = {
    method:   "POST",
    mode:     "cors",
    cache:    "no-cache",
    headers:  headers,
    body:     JSON.stringify(data),
  }
  doFetch(endpoint, options, callback)
}

export const doAuthenticatedPostFormData = (endpoint, form_data, callback = {}) => {
  const windowGlobal = typeof window !== 'undefined' && window
  var token = windowGlobal.localStorage.getItem('billebotAuthToken')
  var headers = new Headers()
  // headers.append("Accept", "application/json")
  // headers.append("Content-Type", "application/x-www-form-urlencoded")
  headers.append("Authorization", `Bearer ${token}`)

  var options = {
    method:   "POST",
    // mode:     "cors",
    // cache:    "no-cache",
    headers:  headers,
    body:     form_data
  }
  doFetch(endpoint, options, callback)
}

export const doAuthenticatedPutFormData = (endpoint, form_data, callback = {}) => {
  const windowGlobal = typeof window !== 'undefined' && window
  var token = windowGlobal.localStorage.getItem('billebotAuthToken')
  var headers = new Headers()
  headers.append("Authorization", `Bearer ${token}`)

  var options = {
    method:   "PUT",
    mode:     "cors",
    cache:    "no-cache",
    headers:  headers,
    body:     form_data
  }
  doFetch(endpoint, options, callback)
}

export const doAuthenticatedPut = (endpoint, data, callback = {}) => {
  const windowGlobal = typeof window !== 'undefined' && window
  var token = windowGlobal.localStorage.getItem('billebotAuthToken')
  var headers = new Headers()
  headers.append("Content-Type", "application/json")
  headers.append("Authorization", `Bearer ${token}`)

  var options = {
    method:   "PUT",
    mode:     "cors",
    cache:    "no-cache",
    headers:  headers,
    body:     JSON.stringify(data)
  }
  doFetch(endpoint, options, callback)
}

export const doAuthenticatedDelete = (endpoint, data, callback = {}) => {
  const windowGlobal = typeof window !== 'undefined' && window
  var token = windowGlobal.localStorage.getItem('billebotAuthToken')
  var headers = new Headers()
  headers.append("Content-Type", "application/json")
  headers.append("Authorization", `Bearer ${token}`)

  var options = {
    method:   "DELETE",
    mode:     "cors",
    cache:    "no-cache",
    headers:  headers,
    body:     JSON.stringify(data)
  }
  doFetch(endpoint, options, callback)
}

export const getSessionExpiredRedirect = () => {
  // Check if user is currently on a portal page
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/portal')) {
    return '/portal/login';
  }
  return '/?session_expired=true';
};

export const doFetch = (endpoint, headers, callback) => {
  fetch(addTimestamp(API_PATH(endpoint)), headers)
  .then(res => res.json())
  .then(res=> {
    if(res.status === "ok" || res.status === "success") {
      if(callback.success) { callback.success(res) }
    } else if (
      res.error === "You need to sign in or sign up before continuing." ||
      res.error === "Not enough or too many segments" ||
      res.error === "Signature has expired"
    ) {
      removeAuthToken()
      window.location = getSessionExpiredRedirect()
    } else if(res.status === "error" || res.error) {
      if(callback.error) { callback.error(res) }
    } else {
      if(callback.general) { callback.general(res) }
    }
  })
  .catch(res => {
    if(callback.catch) { callback.catch(res) }
  })
}

export const doFetchWithHeaders = (endpoint, headers, callback) => {
  var local_headers = {};
  fetch(API_PATH(endpoint), headers)
  .then(res => {
    local_headers = res.headers;
    return res.json()
  })
  .then(res=> {
    if(res.status === "ok" || res.status === "success") {
      if(callback.success) {
        callback.success({...res, headers: local_headers})
      }
    } else if (
      res.error === "You need to sign in or sign up before continuing." ||
      res.error === "Not enough or too many segments" ||
      res.error === "Signature has expired"
    ) {
      removeAuthToken()
      window.location = getSessionExpiredRedirect()
    } else if(res.status === "error" || res.error) {
      if(callback.error) { callback.error(res) }
    }
  })
  .catch(res => {
    if(callback.catch) { callback.catch(res) }
  })
}


// Opens an authenticated file endpoint in a new tab.
//
// A bare window.open cannot carry the bearer token, which is why several endpoints used to
// take the caller's identity from a base64 `?n=` query param instead. Fetch the bytes with
// the Authorization header and hand the browser a blob URL.
export const doAuthenticatedOpenFile = (endpoint, callback = {}) => {
  // Claim the tab synchronously, still inside the click handler's call stack. A window.open
  // deferred into the fetch's .then() reads as a popup and gets blocked.
  const tab = window.open("", "_blank");

  fetch(API_PATH(endpoint), {
    method:  "GET",
    mode:    "cors",
    cache:   "no-cache",
    headers: { "Authorization": getBearerToken() },
  })
  .then(res => {
    if (res.status === 401) {
      if (tab) { tab.close() }
      removeAuthToken()
      window.location = getSessionExpiredRedirect()
      return null
    }
    if (!res.ok) {
      if (tab) { tab.close() }
      if (callback.error) { callback.error(res) }
      return null
    }
    return res.blob()
  })
  .then(blob => {
    if (!blob) { return }
    const url = window.URL.createObjectURL(blob)
    if (tab) { tab.location = url } else { window.open(url, "_blank") }
    // Give the new tab time to load before releasing the object URL.
    window.setTimeout(() => window.URL.revokeObjectURL(url), 60000)
    if (callback.success) { callback.success() }
  })
  .catch(err => {
    if (tab) { tab.close() }
    if (callback.catch) { callback.catch(err) }
  })
}

export const addTimestamp = (endpoint) => {
  const ts = `t=${(new Date).getTime()}`;
  const sep = endpoint.includes("?") ? '&' : '?';
  return endpoint + sep + ts;
}

export const addQueryString = (endpoint, params) => {
  try {
    const qs = Object.keys(params).map(key => key + '=' + params[key]).join('&');
    const sep = endpoint.includes("?") ? '&' : '?';
    return (qs == '') ? endpoint : endpoint + sep + qs;
  } catch(err) {
    return endpoint
  }

}

export const doAuthenticatedGetPromise = (endpoint) => {
  return new Promise((resolve, reject) => {
    const callback = {
      success: (response) => resolve(response),
      error: (error) => reject(error),
      general: (response) => resolve(response),
    };

    doAuthenticatedGet(endpoint, {}, callback);
  });
};